"use client";

import Link from "next/link";
import { megaCategories } from "@/lib/categories";

/** TÜM ÜRÜNLER altında açılan kategori paneli — konumlandırmayı Navbar yapar. */
export function MegaMenu({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="grid gap-6 p-6 sm:grid-cols-2 sm:p-8 lg:grid-cols-3" role="menu" aria-label="Tüm ürün kategorileri">
      {megaCategories.map((cat) => (
        <div key={cat.title} role="none">
          <div className="mb-3 flex items-center justify-between gap-2">
            <Link
              href={cat.href}
              role="menuitem"
              onClick={onNavigate}
              className="text-sm font-bold uppercase tracking-wide text-Primary transition hover:text-Primary-dark"
            >
              {cat.title}
            </Link>
            {cat.badge && (
              <span className="rounded bg-Tertiary px-1.5 py-0.5 text-[10px] font-bold text-White">
                {cat.badge}
              </span>
            )}
          </div>
          <ul className="space-y-2.5">
            {cat.items.map((item) => (
              <li key={item.label}>
                <Link
                  href={item.href}
                  role="menuitem"
                  onClick={onNavigate}
                  className="group flex items-center gap-2 rounded-xl px-3 py-2.5 transition hover:bg-Background-light"
                >
                  <span className="min-w-0 flex-1 truncate text-sm font-medium text-800 group-hover:text-Primary">
                    {item.label}
                  </span>
                  {item.badge && (
                    <span className="shrink-0 rounded bg-Background-dark px-1.5 py-0.5 text-[10px] font-bold text-Primary-dark">
                      {item.badge}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
